import { useMutation } from '@tanstack/react-query';
import { deleteNote } from '@/services/notes/notesService';

interface useDeleteNoteVariables {
  id?: string;
}

export const useDeleteNote = () => {
  return useMutation({
    mutationFn: async ({ id }: useDeleteNoteVariables) => {
      if (id) {
        return deleteNote(id);
      }
    },
  });
};
